import * as types from "./mutation_types";
import { Feed } from "../../../../interfaces/feed";

export default {
  [types.RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: [],
      selectItems: null,
      view: [],
    });
  },

  [types.SET_ERROR](state: any, error: String) {
    Object.assign(state, { error });
  },

  [types.SET_ITEMS](state: any, items: Feed[]) {
    Object.assign(state, {
      error: "",
      items,
    });
  },

  [types.SET_SELECT_ITEMS](state: any, selectItems: Feed[]) {
    Object.assign(state, { selectItems });
  },

  [types.TOGGLE_LOADING](state: any) {
    Object.assign(state, { isLoading: !state.isLoading });
  },

  [types.SET_VIEW](state: any, view: String) {
    Object.assign(state, { view });
  },

  // START:CUSTOM - generated
  [types.SET_TOTAL_ITEMS](state: any, totalItems: number) {
    Object.assign(state, { totalItems });
  },

  [types.SET_ITEMS_PER_PAGE](state: any, itemsPerPage: number) {
    Object.assign(state, { itemsPerPage });
  },

  [types.SET_PAGE_NO](state: any, pageNo: number) {
    Object.assign(state, { pageNo });
  },

  [types.SET_SEARCH](state: any, search: String) {
    Object.assign(state, { search });
  },

  [types.SET_FILTERS](state: any, filters: { by: String, val: String }) {
    Object.assign(state, { filters });
  },

  [types.SET_ORDER_BY](state: any, orderBy: String) {
    Object.assign(state, { orderBy });
  },

  [types.SET_ORDER_DIR](state: any, orderDir: String) {
    Object.assign(state, { orderDir });
  },
  // END:CUSTOM - generated
};
